export default "__VITE_ASSET__D1iw1vng__"